import { Component, Input } from '@angular/core';

@Component({
  selector: 'rwa-tag',
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  @Input({ required: true }) text = '';

  @Input({ required: true }) type = '';
}
